module.exports = __webpack_public_path__ + "eaf2613ea314da93acadb947527a04c4.svg";